'use strict';

DoohApps.factory('AppHardwarRequirement', ['restApi', function (restApi) {
    var controllerName = 'AppStore/';

    return {
        getAppRequirementList: function (successCallback, appVerID) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetAppRequirementList?appVerID='+appVerID);
        },
    }
}]);
